import React from 'react';
import {Button} from '@betareader/design-system';
import {withRouter} from 'react-router-dom';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReactGA from 'react-ga';
import AppIcon from '../../components/AppIcon';

import './publicPages.css';

export const LandingPage = ({changePage}) => (
  <main className='br-public-page'>
    <Button className='br-public-page__cta' onClick={() => changePage('/signup')}>
      Join our Private Beta <AppIcon name='right arrow' aria-hidden='true' />
    </Button>
    <div className='br-public-page__columns'>
      <img
        className='br-public-page__illustration'
        src='/assets/images/reader.jpg'
        alt='Reader enjoying a book'
      />
      <div className='br-public-page__features'>
        <h2>Make Your Story Shine</h2>
        <p>Which beta reader said what? Which feedback is valid and what should I throw away? Use our feedback management tool to make sense of it all.</p>
        <h2>No More Waiting</h2>
        <p>Get notified in real-time as your beta readers make their way through your story and share their feedback with you.</p>
        <h2>All on Your Terms</h2>
        <p>Everything on BetaReader.io is private. You decide who you share your books and stories with, and you can revoke their access with the click of a button.</p>
      </div>
    </div>
    <section className='br-public-page__signup' aria-labelledby='launch-email-heading'>
      <h2 id='launch-email-heading'>Not ready to make the leap?</h2>
      <form
        onSubmit={() => ReactGA.event({
          category: 'Growth',
          action: 'Subscribed to Launch Email'
        })}
        action='https://betareader.us16.list-manage.com/subscribe/post?u=16045d127a0e5000179333ce1&id=83dbceeac1'
        method='post'
        id='mc-embedded-subscribe-form'
        name='mc-embedded-subscribe-form'
      >
        <input
          type='text'
          name='b_16045d127a0e5000179333ce1_83dbceeac1'
          tabIndex={-1}
          aria-hidden='true'
          autoComplete='off'
          className='br-public-page__honeypot'
        />
        <div className='br-public-page__signup-fields'>
          <input
            type='email'
            placeholder='Email Me When You Launch'
            aria-label='Email Me When You Launch'
            name='EMAIL'
            id='mce-EMAIL'
            required
            onFocus={() => ReactGA.event({
              category: 'Growth',
              action: 'Touched Launch Email Input'
            })}
          />
          <Button type='submit' aria-label='Subscribe to launch email'>
            <AppIcon name='mail' aria-hidden='true' />
          </Button>
        </div>
      </form>
    </section>
  </main>
);

const mapStateToProps = state => ({user: state.user.user});
const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage));
